module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAC/SURBVDiNpZPhDYJADIW/GgdgBDYAJ5ANZAMdAUdwAzYxbKATiBuwgWzw/FOTy+UQxC9p0tc073pJC39iqaKkHDhG5c7M+kkDSSdg77IC8qh3AG6eP82sDV+s9Ts1wMY9ihXfL0KD1WwTtR44T/QfgGbOYPBIMS6ZoPZYRMpg9G8AZEDpevQ8mzNozezyEZJeZrbzvAaucwaNpCrQmaSHTxAvV9Ig800MKRN9EOxBN9XwhTvRLVTBLcyRPKxVvAH7aGT5BvkkPwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/homework.png
// module id = IJos
// module chunks = 1